(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  const getpagi = document.querySelector('.AjaxinatePagination');

  if (typeof(getpagi) !== "undefined" && getpagi !== null) {
    document.addEventListener("DOMContentLoaded", function() {
      const elem = getpagi.getAttribute('data-pagination');

      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click'
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    const links = document.querySelectorAll('.collection-card-3 a[href="#"]');

    links.forEach(link => {
      const card = link.closest('.collection-card-3');

      if (card) {
        card.style.display = 'none';
      }
    });
  });

  function ftcParseRgb(value) {
    if (!value) return null;

    var match = value.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([0-9.]+))?\)/);

    if (!match) return null;

    return {
      r: parseInt(match[1], 10),
      g: parseInt(match[2], 10),
      b: parseInt(match[3], 10),
      a: match[4] !== undefined ? parseFloat(match[4]) : 1
    };
  }

  function ftcCompressionLevelFromText(text) {
    var value = (text || '').trim().toLowerCase();

    if (value === 'baja' || value === 'baja compresión' || value === 'low' || value === 'low compression') {
      return 'baja';
    }

    if (value === 'media' || value === 'media compresión' || value === 'medium' || value === 'medium compression') {
      return 'media';
    }

    if (value === 'alta' || value === 'alta compresión' || value === 'high' || value === 'high compression') {
      return 'alta';
    }

    return '';
  }

  function ftcRemoveOldCompressionClasses(scope) {
    if (!scope) return;

    var oldClasses = [
      'ftc-compression-label',
      'ftc-compression-label--alta',
      'ftc-compression-label--media',
      'ftc-compression-label--baja',
      'ftc-compression-label--high',
      'ftc-compression-label--medium',
      'ftc-compression-label--low',
      'ftc-compression-soft-label',
      'ftc-compression-soft-label--alta',
      'ftc-compression-soft-label--media',
      'ftc-compression-soft-label--baja',
      'ftc-compression-segment',
      'ftc-compression-segment--active',
      'ftc-compression-segment--inactive',
      'ftc-compression-segment--alta',
      'ftc-compression-segment--media',
      'ftc-compression-segment--baja',
      'ftc-compression-segment--high',
      'ftc-compression-segment--medium',
      'ftc-compression-segment--low',
      'ftc-compression-choice',
      'ftc-compression-choice--active',
      'ftc-compression-choice--inactive',
      'ftc-compression-choice--baja',
      'ftc-compression-choice--media',
      'ftc-compression-choice--alta'
    ];

    scope.querySelectorAll('*').forEach(function(el) {
      oldClasses.forEach(function(className) {
        el.classList.remove(className);
      });
    });
  }

  function ftcElementHasActiveState(el, boundary) {
    var node = el;

    while (node && node !== boundary && node.nodeType === 1) {
      var className = '';

      if (typeof node.className === 'string') {
        className = node.className.toLowerCase();
      } else if (node.className && typeof node.className.baseVal === 'string') {
        className = node.className.baseVal.toLowerCase();
      }

      if (/active|selected|current|checked|is-active/.test(className)) {
        return true;
      }

      if (
        node.getAttribute('aria-selected') === 'true' ||
        node.getAttribute('aria-pressed') === 'true' ||
        node.getAttribute('data-active') === 'true' ||
        node.getAttribute('data-selected') === 'true'
      ) {
        return true;
      }

      node = node.parentElement;
    }

    return false;
  }

  function ftcElementLooksOriginallyActive(el) {
    if (!el) return false;

    var computed = window.getComputedStyle(el);
    var bg = ftcParseRgb(computed.backgroundColor);
    var color = ftcParseRgb(computed.color);

    if (!bg || bg.a === 0) return false;

    var looksRed = bg.r >= 120 && bg.g <= 110 && bg.b <= 130;
    var looksDark = bg.r <= 90 && bg.g <= 90 && bg.b <= 90;
    var textLooksLight = color && color.r >= 200 && color.g >= 200 && color.b >= 200;

    return looksRed || (looksDark && textLooksLight);
  }

  function ftcFindCompressionElements(item) {
    var candidates = item.querySelectorAll('span, small, a, button, li, div');
    var found = [];

    candidates.forEach(function(el) {
      if (el.children && el.children.length > 0) return;

      var level = ftcCompressionLevelFromText(el.textContent);

      if (!level) return;

      found.push({
        element: el,
        level: level
      });
    });

    return found;
  }

  function ftcFindCompressionGroup(item, compressionItems) {
    if (!compressionItems || compressionItems.length < 2) return null;

    var first = compressionItems[0].element;
    var node = first.parentElement;

    while (node && node !== item) {
      var text = node.textContent.toLowerCase();
      var hasBaja = text.indexOf('baja') !== -1 || text.indexOf('low') !== -1;
      var hasMedia = text.indexOf('media') !== -1 || text.indexOf('medium') !== -1;
      var hasAlta = text.indexOf('alta') !== -1 || text.indexOf('high') !== -1;

      if ((hasBaja && hasMedia) || (hasBaja && hasAlta) || (hasMedia && hasAlta)) {
        return node;
      }

      node = node.parentElement;
    }

    return first.parentElement;
  }

  function ftcStyleCompressionActiveOnly(item) {
    if (!item) return;

    ftcRemoveOldCompressionClasses(item);

    var compressionItems = ftcFindCompressionElements(item);

    if (!compressionItems || compressionItems.length < 2) return;

    var group = ftcFindCompressionGroup(item, compressionItems);

    if (!group) return;

    var activeItem = null;

    compressionItems.forEach(function(entry) {
      if (!activeItem && ftcElementHasActiveState(entry.element, group)) {
        activeItem = entry;
      }
    });

    compressionItems.forEach(function(entry) {
      if (!activeItem && ftcElementLooksOriginallyActive(entry.element)) {
        activeItem = entry;
      }
    });

    group.classList.add('ftc-compression-group-fixed');

    compressionItems.forEach(function(entry) {
      entry.element.classList.add('ftc-compression-choice');
      entry.element.classList.add('ftc-compression-choice--' + entry.level);
    });

    if (activeItem && activeItem.element) {
      activeItem.element.classList.add('ftc-compression-choice--active');
    }
  }

  function ftcApplyProductStageLabels() {
    var productItems = document.querySelectorAll('[data-ftc-grid-product-item]');

    productItems.forEach(function(item) {
      var target =
        item.querySelector('.card__information') ||
        item.querySelector('.card-information') ||
        item.querySelector('.product-card__info') ||
        item.querySelector('.product-card__content') ||
        item.querySelector('.product-item__info') ||
        item.querySelector('.product-card') ||
        item.querySelector('.card__content') ||
        item;

      var source = item.querySelector('[data-ftc-product-stage-source]');

      if (source && target && !target.querySelector('.ftc-product-stage-row')) {
        var row = document.createElement('div');
        row.className = 'ftc-product-stage-row';
        row.innerHTML = source.innerHTML;

        var swatchTarget =
          target.querySelector('.color-swatch') ||
          target.querySelector('.swatch') ||
          target.querySelector('.product-card__swatches') ||
          target.querySelector('.card__swatches');

        var titleTarget =
          target.querySelector('.card__heading') ||
          target.querySelector('.product-card__title') ||
          target.querySelector('.product-card-title') ||
          target.querySelector('h3') ||
          target.querySelector('h4');

        if (swatchTarget && swatchTarget.parentNode) {
          swatchTarget.parentNode.insertBefore(row, swatchTarget);
        } else if (titleTarget && titleTarget.parentNode) {
          titleTarget.insertAdjacentElement('afterend', row);
        } else {
          target.insertBefore(row, target.firstChild);
        }
      }

      ftcStyleCompressionActiveOnly(item);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    ftcApplyProductStageLabels();

    setTimeout(function() {
      ftcApplyProductStageLabels();
    }, 400);

    setTimeout(function() {
      ftcApplyProductStageLabels();
    }, 1200);

    var productGrid = document.querySelector('#product-grid');

    if (productGrid) {
      var observer = new MutationObserver(function() {
        ftcApplyProductStageLabels();
      });

      observer.observe(productGrid, {
        childList: true,
        subtree: true
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
